import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import AlertModal from 'components/common-components/AlertModal';
import AttachmentsOverviewContent from 'pages/submissions/AttachmentsOverviewContent';
import SingleCheckBoxField from 'components/form-components/SingleCheckBoxField';
import attendanceMediaIcon from 'assets/images/icons/attendance-media.svg';
import attendanceMediaGreyIcon from 'assets/images/icons/attendance-media-grey.svg';
import TableUtils from 'components/table-component/TableUtils';
import NestedTableWithDragComponent from './NestedTableWithDrag';
import BottomArrow from 'assets/images/icons/dashboard-arrow-bottom.svg';
import RightArrow from 'assets/images/icons/dashboard-arrow-right.svg';
import DragIcon from 'assets/images/icons/drag-icon.svg';
import DropZone from 'pages/form/MidSectionComponents/DropZone';

const NestedTableWithDragData = ({
  data,
  tableFields,
  props,
  isActionsEnabled,
  onSelection,
  isSelectionEnabled,
  selectionKey,
  selectedRows,
  nestedTableProps,
}) => {
  const [detail, setDetails] = useState(data);
  useEffect(() => {
    setDetails(data);
  }, [data]);
  const [nestedOpenedRecordIds, setNestedOpenedRecordIds] = useState([]);
  let { actionsType, actionsCallBack, type, attendanceMediaNote, translateValueFunc, isDragable } =
    {
      ...props,
    };
  const [showMediaModal, setShowMediaModal] = useState(false);
  const [mediaAndNotes, setMediaAndNotes] = useState({
    media: [],
    note: '',
    showTimeStamp: false,
    mediaTimeStampString: {},
    dialogType: '',
  });
  const showMedia = (mediaNotes, formVersionId, showTimeStamp, dialogType) => {
    setShowMediaModal(true);
    setMediaAndNotes({
      ...mediaNotes,
      showTimeStamp: false,
      mediaTimeStampString: {},
      dialogType,
    });
  };
  const closeModal = () => {
    setShowMediaModal(false);
    setMediaAndNotes({ media: [], note: '' });
  };
  const [draggedRow, setDraggedRow] = useState(null);
  const [hoveredRow, setHoveredRow] = useState(null);

  const handleDragStart = (e, id) => {
    setDraggedRow(id);
    e.dataTransfer.effectAllowed = 'move';
  };
  const handleDragOver = (e, id) => {
    setHoveredRow(id);
    e.dataTransfer.effectAllowed = 'move';
  };

  const handleDrop = (id) => {
    console.log(id, draggedRow);
    setDraggedRow(null);
    setHoveredRow(null);
  };
  return (
    <Fragment>
      <tbody>
        {detail &&
          detail.map((singleRecord) => {
            return (
              <React.Fragment key={singleRecord._id}>
                <tr className='table-checkbox'>
                  {isDragable ? (
                    <td
                      className='action-icon'
                      draggable
                      onDragStart={(e) => handleDragStart(e, singleRecord._id)}
                    >
                      <img className='cursor-pointer' src={DragIcon} />
                    </td>
                  ) : null}
                  {nestedTableProps?.isNestedTableAllowed ? (
                    <td
                      className='action-icon'
                      onClick={() => {
                        setNestedOpenedRecordIds((prev) => {
                          if (prev.includes(singleRecord._id)) {
                            return prev.filter((id) => id !== singleRecord._id);
                          } else {
                            return [...prev, singleRecord._id];
                          }
                        });
                      }}
                    >
                      <img
                        className='cursor-pointer'
                        src={
                          nestedOpenedRecordIds.includes(singleRecord._id)
                            ? BottomArrow
                            : RightArrow
                        }
                      />
                    </td>
                  ) : null}
                  {isSelectionEnabled ? (
                    <td>
                      <SingleCheckBoxField
                        name={selectionKey
                          .split('.')
                          .reduce((acc, curr) => acc[curr], singleRecord)}
                        value={
                          selectedRows
                            .map((e) => (e.id ? e.id : e))
                            .indexOf(
                              selectionKey
                                .split('.')
                                .reduce((acc, curr) => acc[curr], singleRecord),
                            ) > -1
                            ? true
                            : false
                        }
                        handleChange={onSelection}
                        disabled={
                          type === 'submissions' && singleRecord.entryStatus !== 'complete_entry'
                        }
                        text={<></>}
                        classes=''
                      />
                    </td>
                  ) : null}
                  {tableFields.map((singleHeaderField, index1) => {
                    let value = singleHeaderField.associatedKey;
                    let callbackFunc = singleHeaderField.callbackFunc
                      ? props[singleHeaderField.callbackFunc]
                      : null;
                    return singleHeaderField.isSelected ? (
                      <td
                        key={index1}
                        className={type === 'data_source_filter_list' ? 'nowrap' : ''}
                      >
                        {type === 'attendance' &&
                        attendanceMediaNote &&
                        singleRecord &&
                        singleRecord._id &&
                        attendanceMediaNote[singleRecord._id] &&
                        attendanceMediaNote[singleRecord._id][singleHeaderField.name] ? (
                          <div className={`d-flex justify-content-between gap-2`}>
                            {singleHeaderField.populateFunc
                              ? TableUtils[singleHeaderField.populateFunc](
                                  value
                                    ? value
                                        .split('.')
                                        .reduce((acc, curr) => acc[curr], singleRecord)
                                    : singleRecord,
                                  callbackFunc,
                                  singleHeaderField.translateVal ? translateValueFunc : null,
                                )
                              : value && singleRecord
                              ? value.split('.').reduce((acc, curr) => acc[curr], singleRecord)
                              : ''}

                            <img
                              onClick={() => {
                                let singleObj =
                                  attendanceMediaNote[singleRecord._id][singleHeaderField.name];
                                if (singleObj.media || singleObj.note) {
                                  showMedia(
                                    {
                                      userName:
                                        singleRecord.firstName || singleRecord.lastName
                                          ? singleRecord.firstName + ' ' + singleRecord.lastName
                                          : '',
                                      note: singleObj.note ? singleObj.note : '',
                                      media: singleObj.media ? singleObj.media : [],
                                    },
                                    'form_version_id',
                                    false,
                                    'attendance',
                                  );
                                }
                              }}
                              className='cursor-pointer'
                              src={
                                attendanceMediaNote[singleRecord._id][singleHeaderField.name]
                                  .note ||
                                attendanceMediaNote[singleRecord._id][singleHeaderField.name].media
                                  ? attendanceMediaIcon
                                  : attendanceMediaGreyIcon
                              }
                            />
                          </div>
                        ) : type === 'dashboardFormsStructure' &&
                          singleHeaderField.populateFuncFromProps ? (
                          <div>
                            {props[singleHeaderField.populateFuncFromProps](
                              singleHeaderField.name,
                              singleRecord,
                            )}
                          </div>
                        ) : singleHeaderField.populateFunc ? (
                          TableUtils[singleHeaderField.populateFunc](
                            value
                              ? value.split('.').reduce((acc, curr) => acc[curr], singleRecord)
                              : singleRecord,
                            callbackFunc,
                            singleHeaderField.translateVal
                              ? translateValueFunc
                              : singleHeaderField.filterKey
                              ? singleHeaderField.filterKey
                              : null,
                            singleHeaderField.sendRowWithKeyValue
                              ? { row: singleHeaderField, key: singleHeaderField.name }
                              : null,
                          )
                        ) : value && singleRecord ? (
                          value.split('.').reduce((acc, curr) => acc[curr], singleRecord)
                        ) : (
                          ''
                        )}
                      </td>
                    ) : null;
                  })}
                  {isActionsEnabled && (
                    <td className='d-flex justify-content-end align-items-center'>
                      {TableUtils['actionsList'](singleRecord, actionsType, actionsCallBack)}
                    </td>
                  )}
                </tr>
                {nestedTableProps?.isNestedTableAllowed &&
                  nestedOpenedRecordIds.includes(singleRecord._id) && (
                    <tr>
                      <td colSpan={10}>
                        <NestedTableWithDragComponent
                          header={nestedTableProps.nestedTableHeader}
                          data={singleRecord[nestedTableProps.nestedTableDataKey]}
                          props={{
                            type: type,
                            isNested: true,
                            isDragable: nestedTableProps.isDragable,
                            ...nestedTableProps.props,
                          }}
                          totalRecords={singleRecord[nestedTableProps.nestedTableDataKey].length}
                          filterEnabled={false}
                          loader={false}
                          isFieldSelectionEnabled={false}
                          isPaginationEnabled={false}
                          isActionsEnabled={true}
                          isSelectionEnabled={false}
                          selectionKey={'_id'}
                          paginationFunction={null}
                          // onSelection={onRowsSelection}
                          selectedRows={[]}
                          maintainTableHeight={false}
                        />
                      </td>
                    </tr>
                  )}
                {isDragable && (
                  <tr
                    onDragOver={(e) => handleDragOver(e, singleRecord._id)}
                    onDrop={() => handleDrop(singleRecord._id)}
                  >
                    <td colSpan={10} className='droppable-area'>
                      {hoveredRow === singleRecord._id && (
                        <DropZone
                          onComponentDrop={() => handleDrop(singleRecord._id)}
                          clearDrag={() => setDraggedRow(null)}
                          shrink
                          dropAllowed={true}
                        />
                      )}
                    </td>
                  </tr>
                )}
              </React.Fragment>
            );
          })}
      </tbody>
      <AlertModal
        show={showMediaModal}
        closeModal={closeModal}
        showCloseButton
        size='lg'
        actionButtons={[]}
      >
        {showMediaModal ? <AttachmentsOverviewContent mediaAndNotes={mediaAndNotes} /> : <></>}
      </AlertModal>
    </Fragment>
  );
};

NestedTableWithDragData.propTypes = {
  selectedRows: PropTypes.array,
  data: PropTypes.array.isRequired,
  tableFields: PropTypes.array.isRequired,
  props: PropTypes.object.isRequired,
  isActionsEnabled: PropTypes.bool.isRequired,
  isSelectionEnabled: PropTypes.bool,
  selectionKey: PropTypes.string,
  onSelection: PropTypes.func,
  nestedTableProps: PropTypes.object,
};

export default NestedTableWithDragData;
